import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package, Loader2 } from "lucide-react";
import api from "../lib/api";

const STATUS_COLORS = {
  processing: "bg-brand-yellow",
  shipped: "bg-brand",
  delivered: "bg-brand-green",
  cancelled: "bg-brand-pink text-white",
};

export default function Orders() {
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    api.get("/orders").then((r) => setOrders(r.data)).catch(() => setOrders([]));
  }, []);

  if (orders === null) return (
    <div className="min-h-[60vh] flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-brand" /></div>
  );

  if (orders.length === 0) return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="no-orders">
      <div className="w-20 h-20 mx-auto rounded-full border-2 border-ink bg-brand-yellow flex items-center justify-center mb-6 shadow-hard"><Package className="w-9 h-9" /></div>
      <h1 className="text-3xl font-black mb-3">No orders yet</h1>
      <p className="text-muted-foreground mb-8">When you snag something, it'll show up here.</p>
      <Link to="/shop" className="inline-flex px-8 py-4 rounded-full font-bold bg-brand text-white border-2 border-ink shadow-hard-btn hover:translate-y-[3px] hover:shadow-none transition-all">Start Shopping</Link>
    </div>
  );

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-10" data-testid="orders-page">
      <h1 className="text-4xl font-black tracking-tighter mb-8">My Orders</h1>
      <div className="space-y-5">
        {orders.map((o) => (
          <div key={o.id} className="bg-white rounded-3xl border-2 border-ink shadow-hard p-5" data-testid={`order-${o.id}`}>
            <div className="flex flex-wrap items-center justify-between gap-3 mb-4 pb-4 border-b-2 border-dashed border-ink">
              <div>
                <p className="text-xs font-bold uppercase tracking-wider text-muted-foreground">Order</p>
                <p className="font-black">#{o.id.slice(-8).toUpperCase()}</p>
              </div>
              <p className="text-sm font-medium text-muted-foreground">{new Date(o.created_at).toLocaleDateString()}</p>
              <span className={`rounded-full px-4 py-1.5 text-xs font-black uppercase border-2 border-ink ${STATUS_COLORS[o.status] || "bg-secondary"}`}>{o.status}</span>
              <p className="text-xl font-black">${o.amount.toFixed(2)}</p>
            </div>
            <div className="space-y-3">
              {o.items.map((it, i) => (
                <div key={i} className="flex items-center gap-3">
                  <img src={it.image} alt={it.title} className="w-14 h-14 rounded-xl object-cover border-2 border-ink" />
                  <div className="flex-1 min-w-0"><p className="font-bold truncate">{it.title}</p><p className="text-sm text-muted-foreground">Qty {it.quantity} · ${it.price.toFixed(2)}</p></div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
